module.exports = __webpack_public_path__ + "static/media/jumotrom.173489b9.png";